// Utility function to handle API responses
export const handleResponse = async <T>(promise: Promise<any>): Promise<T> => {
  const response = await promise
  if (response.data.success) {
    return response.data.data // Return the data field if success
  } else {
    throw new Error("API request failed") // Handle failure
  }
}

export * from "./accounts"
export * from "./quotes"
export * from "./token"
export * from "./auth"
